import React, { Suspense, lazy } from 'react'
import { MonthlyCalendarProps } from '../../interfaces/calendar'

const Calendar = lazy(() => import(/* webpackPrefetch: true */ './MonthlyCalendar'))

export function MonthlyCalendarContainer({ user, role }: MonthlyCalendarProps): JSX.Element {
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Calendar user={user} role={role} />
      </Suspense>
    </div>
  )
}
